import React from "react"
import { connect } from "react-redux"
import store from "../../../shared_component/utils/configureStore"
import { elements } from "caradvise_shared_components"
import Rating from "react-rating"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar as fasSolidStar } from "@fortawesome/free-solid-svg-icons"
import { faStar, faTimes } from "@fortawesome/pro-light-svg-icons"
import { Form, TextArea, Grid, Header } from "semantic-ui-react"
import { Button as SemanticButton } from "semantic-ui-react"
import { createRating } from "../../actions/rating"
import Notifications from "../../components/Notifications"
import Button from "../Button"
import { withTranslation } from "react-i18next"

const { BaseModalDialog } = elements

class ShopOrderRatingModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      score: null,
      tagIds: [],
      customerExplanation: "",
      isOpen: true,
      isSubmitting: false
    }
  }

  closeModal = () => {
    this.setState({ isOpen: false })
  }

  showRatingSubmitSuccess = () => {
    const { t } = this.props
    store.dispatch(
      Notifications.success({
        title: t("successLbl"),
        message: t("ratingSubmittedSuccessMessage"),
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
  }

  handleSubmit = () => {
    const { tagIds, score, customerExplanation } = this.state

    const payload = {
      shopOrderRatingTagIds: tagIds,
      score: this.state.score,
      customerExplanation: this.state.customerExplanation,
      shopOrderId: this.props.shopOrderId
    }

    this.setState({ isSubmitting: true })

    this.props.createRating(payload).then((response) => {
      if (response === true) this.showRatingSubmitSuccess()
      this.setState({ isOpen: false })
      this.setState({ isSubmitting: false })
    })
  }

  handleDismiss = () => {
    const payload = {
      dismissed: true,
      shopOrderId: this.props.shopOrderId
    }

    this.props.createRating(payload)
    this.closeModal()
  }

  handleTextAreaChange = (e) => {
    this.setState({ customerExplanation: e.target.value })
  }

  handleRateChange = (score) => {
    this.setState({ score })
  }

  handleTagButtonToggle = (tagId) => {
    const { tagIds } = this.state
    const idPresent = tagIds.find((id) => id === tagId)
    this.setState({
      tagIds: idPresent ? tagIds.filter((id) => id !== tagId) : tagIds.concat(tagId)
    })
  }

  shopRatingTagButtons = () => {
    const { tagIds } = this.state
    const tagButtons = this.props.tags.map((tag, index) => (
      <SemanticButton
        toggle
        className="shop-order-rating-tag-button"
        size={"mini"}
        active={tagIds.includes(tag.id)}
        onClick={() => this.handleTagButtonToggle(tag.id)}
      >
        {tag.name}
      </SemanticButton>
    ))

    return tagButtons
  }

  render() {
    const { ratableShopOrderInfo, shop, t } = this.props
    const { isSubmitting, score } = this.state

    // Possibly adding later. Andrew said - leave commented for now
    // const scoreToPhraseMap = {
    //   1: 'Really Bad',
    //   2: 'Not Great'
    //   3: 'OK',
    //   4: 'Good',
    //   5: 'Great!'
    // }
    // <div>{scoreToPhraseMap[this.state.score]}</div>

    return (
      <BaseModalDialog
        isOpen={this.state.isOpen}
        headerTitle={<h2 className="primary-font confident-blue">{t("rateTheShopLbl")}</h2>}
        toggleModal={this.closeModal}
        overflow
      >
        <div className={"shop-order-ratings-content"}>
          <div className={"shop-order-rating-modal-question"}>{t("howWasYourExperienceText")}</div>
          <p>
            <strong>{shop.company && shop.company.name ? shop.company.name : shop.name}</strong>?
          </p>
          <div className="shop-order-rating-stars-wrapper">
            <Rating
              emptySymbol={<FontAwesomeIcon color="gold" size="2x" icon={faStar} />}
              fullSymbol={<FontAwesomeIcon color="gold" size="2x" icon={fasSolidStar} />}
              onChange={this.handleRateChange}
              initialRating={this.state.score}
            />
          </div>
          <div>{t("leaveComplimentText")}</div>
          <div className={"shop-order-rating-tag-button-container"}>
            <Grid stackable fluid padded centered>
              <Grid.Row>{this.shopRatingTagButtons()}</Grid.Row>
            </Grid>
          </div>
          <div className="ratings-leave-feedback-text">{t("leaveFeedbackText")}</div>
          <Form>
            <TextArea
              className={"shop-order-rating-modal-text-area"}
              onChange={this.handleTextAreaChange}
              placeholder={t("addCommentsPlaceholder")}
            />
          </Form>

          <Button
            disabled={this.isSubmitting || score == null}
            style={{ width: "150px", height: "25px", marginTop: "15px" }}
            onClick={this.handleSubmit}
            colorStyle="orange"
            text={t("submitBtn")}
          />

          <div
            style={{ marginTop: "10px" }}
            className="underline caradvise-orange"
            onClick={this.handleDismiss}
          >
            {t("noThanksLbl")}
          </div>
        </div>
      </BaseModalDialog>
    )
  }
}

const mapStateToProps = (state, props) => {
  const { user } = state
  const ratableShopOrderInfo = (user.ratable_shop_order_info || [])[0] || {}

  // For some reason the shop data is sometimes coming in under a `v4_shop` namespace.
  // TODO: Figure this out and fix the root cause
  let shop = ratableShopOrderInfo.shop || {}
  const v4Shop = shop.v4_shop
  if (v4Shop) shop = v4Shop

  return {
    ratableShopOrderInfo: ratableShopOrderInfo,
    shopOrderId: ratableShopOrderInfo.shop_order_id,
    tags: ratableShopOrderInfo.tags,
    shop: shop
  }
}

export default connect(mapStateToProps, { createRating })(
  withTranslation("shopOrderRatingModal")(ShopOrderRatingModal)
)
